<template>
	<div class="profile-content-container">
		<!-- <div class="profile-actions-container">
			<div class="actions-left">
				<div>
					<md-button class="jb-standard send-offer-btn">
						<md-icon class="btn-text-icon active">send </md-icon>
						Send Offer
					</md-button>
					<md-button class="btn-text"> <md-icon class="btn-text-icon">calendar_month </md-icon> Invite to Interview</md-button>
				</div>
			</div>
			<div class="actions-right">
				<md-button class="btn-text" @click="toggleFavourite">
					<md-icon class="btn-text-icon" :class="{ favourited: isFavourited }">
						{{ isFavourited ? 'favorite' : 'favorite_border' }}
					</md-icon>
					{{ favouriteButtonText }}
				</md-button>
			</div>
		</div> -->
		<div v-if="loading" class="background">
			<div v-if="loading" class="logo-position lds-circle">
				<div><img src="@/assets/img/logo.png" /></div>
			</div>
		</div>
		<div class="content" v-if="!loading">
			<div class="content-left">
				<div class="main-information">
					<div style="display: flex; width: 100%; justify-content: space-between; align-items: center">
						<div style="display: flex; align-items: center">
							<img v-if="profile.profile" class="img" :src="profile.profile" />
							<img v-if="!profile.profile" class="img" :src="cardUserImage" />
							<div>
								<h4>{{ profile.name + ' ' + profile.surname }}</h4>
								<h4>{{ lastQualification.degree }} ({{ lastQualification.year }})</h4>
								<h5>{{ lastQualification.institution }}</h5>
								<p v-if="profile && profile.careerTrack" class="tag-pill">{{ profile.careerTrack }}</p>
							</div>
						</div>
						<md-button class="btn-text" style="height: fit-content !important" @click="toggleFavourite">
							<md-icon class="btn-text-icon" :class="{ favourited: isFavourited }">
								{{ isFavourited ? 'star' : 'star_border' }}
							</md-icon>
							{{ favouriteButtonText }}
						</md-button>
					</div>
				</div>

				<div class="document-container border">
					<!-- Resume -->
					<md-button v-if="profile && profile.cv && profile.cv.url" class="btn-text" @click="viewResume">
						<md-icon class="btn-text-icon">description</md-icon>
						View Resume
					</md-button>

					<!-- Video Submissions -->
					<md-button v-if="profile.videoSubmissionUrl" class="btn-text" @click="viewVideoSubmission">
						<md-icon class="btn-text-icon">videocam</md-icon>
						Video Submissions
					</md-button>

					<!-- Written Submissions -->
					<md-button v-if="profile.writtenSubmissionUrl" class="btn-text" @click="viewWrittenSubmission">
						<md-icon class="btn-text-icon">description</md-icon>
						Written Submissions
					</md-button>
				</div>
				<!-- Only show if user is employer AND we have results -->
				<div v-if="skillsAssessmentResults.length > 0" class="section-container border">
					<h4 class="section-title"><md-icon>assignment </md-icon> Skills Assessment</h4>
					<table class="assessment-table">
						<thead>
							<tr>
								<th>Skill</th>
								<th>Score</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(result, index) in skillsAssessmentResults" :key="index">
								<td>{{ result.skillName }}</td>
								<td>
									<span v-if="result.status === 'Not Attempted'">Not Attempted</span>
									<span v-else>{{ result.percentage }}%</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div v-if="profile.introductoryVideoUrl" class="video-container border">
					<h4><md-icon>videocam</md-icon> Introductory Video</h4>

					<div class="video-player" :class="{ blurred: !this.auth }">
						<template>
							<iframe
								:src="embeddedVideoUrl"
								width="100%"
								height="100%"
								frameborder="0"
								allowfullscreen
								allow="camera; microphone; fullscreen; display-capture"
							></iframe>
						</template>
					</div>
					<button v-if="!this.auth" class="login-overlay-button" @click="promptLogin">Log in to view</button>
				</div>

				<div v-if="profile.qualifications.length > 0" class="section-container border">
					<h4 class="section-title"><md-icon>school </md-icon> Education</h4>
					<div class="section-card" v-for="(qualification, index) in profile.qualifications" :key="index">
						<div class="section-left">
							<h3>{{ qualification.degree }}</h3>
							<h4>{{ qualification.institution }}</h4>
							<h4>Year of Study: {{ qualification.year }}</h4>
						</div>
						<div>
							<h4>
								{{ qualification.startDate }}
								-
								{{ qualification.endDate && qualification.endDate !== 'Invalid date' ? qualification.endDate : 'Present' }}
							</h4>

							<!-- Academic Transcript in each qualification (assuming it's available) -->
							<md-button
								class="btn-text"
								@click="viewAcademicTranscript(qualification.academicTranscript.url)"
								v-if="qualification.academicTranscript && qualification.academicTranscript.url"
							>
								<md-icon class="btn-text-icon">file_download</md-icon>
								View Transcript
							</md-button>
						</div>
					</div>
				</div>

				<div v-if="profile.experiences.length > 0" class="section-container border">
					<h4 class="section-title"><md-icon>school </md-icon> Experience</h4>
					<div :class="{ blurred: !this.auth }">
						<div class="section-card" v-for="(experience, index) in profile.experiences" :key="index">
							<div class="section-left">
								<h3>{{ experience.jobTitle }}</h3>
								<h4 style="margin-bottom: 1rem">{{ experience.employer }}</h4>
								<p>{{ experience.description }}</p>
							</div>
							<div>
								<h4 class="section-dates">
									{{ experience.startDate }} - {{ experience.endDate && experience.endDate !== 'Invalid date' ? experience.endDate : 'Present' }}
								</h4>
							</div>
						</div>
					</div>
					<button v-if="!this.auth" class="login-overlay-button" @click="promptLogin">Log in to view</button>
				</div>
				<br />
				<br />
			</div>
			<div class="content-right">
				<!-- Contact Info -->

				<div class="section-box contact">
					<h4 class="section-header"><md-icon>call</md-icon> Contact Information</h4>
					<div :class="{ blurred: !this.auth }">
						<p>Email: {{ profile.email }}</p>
						<p>Phone: {{ profile.phone }}</p>
						<p v-if="profile && profile.location && profile.location.formattedAddress">Location: {{ profile.location.formattedAddress }}</p>
					</div>
					<button v-if="!this.auth" class="login-overlay-button" @click="promptLogin">Log in to view</button>
				</div>

				<div class="section-box">
					<h4 class="section-header"><md-icon>build</md-icon> Skills</h4>

					<div class="section-content wrap" v-if="passedSkills.length">
						<p class="tag-pill" v-for="skill in passedSkills" :key="skill.id">
							{{ skill.id }}
						</p>
					</div>
					<p v-else>No passed skills found</p>
				</div>

				<!-- Preferred Companies -->
				<div v-if="profile && profile.preferredCompanies && profile.preferredCompanies.choices && profile.preferredCompanies.choices.length > 0" class="section-box">
					<h4 class="section-header"><md-icon>business</md-icon> Preferred Companies</h4>
					<ul v-if="profile && profile.preferredCompanies && profile.preferredCompanies.choices && profile.preferredCompanies.choices.length > 0">
						<li v-for="(preferred_company, index) in profile.preferredCompanies.choices" :key="index">
							{{ preferred_company }}
						</li>
					</ul>
					<p v-else>No Preferred Companies Data Found</p>
				</div>

				<!-- Preferred Departments -->
				<div v-if="profile && profile.preferredCompanies && profile.preferredCompanies.department && profile.preferredCompanies.department.length > 0" class="section-box">
					<h4 class="section-header"><md-icon>business</md-icon> Preferred Departments</h4>
					<div class="section-content wrap">
						<p class="tag-pill" v-for="(preferred_department, index) in profile.preferredCompanies.department" :key="index">
							{{ preferred_department.department }}
						</p>
					</div>
				</div>
			</div>
		</div>

		<!-- Notes & Comments -->
		<div class="section-box no-top-margin" v-if="this.auth">
			<applicant-comments-modal v-if="status === 'jobs'" :userProfile="userProfile" :jobId="jobId" />
			<talent-pool-comments-modal
				v-if="isTalentPool && currentTalentPool && userProfile && userProfile.userId"
				:userProfile="userProfile"
				:currentTalentPool="currentTalentPool"
				:isTalentPool="isTalentPool"
			/>

			<h4 class="section-header"><md-icon>chat_bubble_outline</md-icon> Notes & Comments</h4>
			<textarea name="comments" id="comments" cols="30" rows="4" placeholder="Add notes about this candidate..." class="comment-input"></textarea>
			<md-button class="btn-text full-width"> <md-icon class="btn-text-icon">add_circle_outline</md-icon> Save Comment</md-button>
		</div>

		<div v-if="errorAuth">
			<modal>
				<template #body>
					<div>
						<p>{{ authError }}</p>
					</div>
				</template>

				<template #footer>
					<div style="display: flex; flex-direction: row; justify-content: space-between">
						<md-button class="md-primary" style="color: white !important; margin-right: 20px" @click="promptLogin">Login</md-button>
						<md-button class="md-danger" style="color: white !important" @click="errorAuth = false">Cancel</md-button>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>
<script>
import db from '@/firebase/init';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import ApplicantCommentsModal from '@/components/Modals/ApplicantCommentsModal.vue';
import TalentPoolCommentsModal from '@/components/Modals/TalentPoolCommentsModal.vue';
import ViewAcademicTranscript from '@/views/dashboard/client/jobs/applications/applicants/ViewAcademicTranscript.vue';
import { posthog } from '@/posthog/postHog.js';
import { Modal } from '@/components';
import firebase from 'firebase/compat/app';

export default {
	components: {
		ApplicantCommentsModal,
		TalentPoolCommentsModal,
		Modal,
	},
	props: {
		showStatus: {
			type: String,
			default: null,
		},
		currentTalentPool: {
			type: Object,
			default: null,
		},
		userProfile: {
			type: Object,
		},
		favourite: {
			type: Boolean,
			default: false,
		},
		showFavoriteButton: {
			type: Boolean,
			default: false,
		},
		jobId: {
			type: String,
		},
		isTalentPool: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			cardUserImage: '/img/dashboard/client/card-1.jpg',
			profile: {},
			favouriteButtonText: '',
			user: this.userProfile.alias,
			commentsModal: false,
			talentCommentsModal: false,
			applicationId: '',
			isAcademicTranscript: false,
			academicTranscript: null,
			jobData: null,
			isFavourited: false,
			skillsAssessmentResults: [],
			loading: false,
			errorAuth: false,
			authError: '',
			auth: null,
		};
	},
	methods: {
		async fetchSkillsAssessmentResults() {
			const jobSkillsDoc = await db.collection('skills').doc(this.jobId).get();
			if (!jobSkillsDoc.exists) {
				this.skillsAssessmentResults = [];
				return;
			}

			const jobSkills = jobSkillsDoc.data().skills || [];

			// Fetch vetting tests in advance
			const vettingSnapshot = await db.collection('vettingTests').where('userId', '==', this.userProfile.studentId).get();

			const vettingTests = vettingSnapshot.docs.map(doc => doc.data());

			// Process all skills in parallel
			const skillResults = await Promise.all(
				jobSkills.map(async skill => {
					const rawSkillName = skill.skillName;
					const skillName = rawSkillName.trim();
					const normalizedSkill = skillName.toLowerCase();

					let status = 'Not Attempted';
					let pass = false;
					let jobSource = '—';
					let score = 0;
					let totalPoints = 100;

					let studentSkillDoc;

					studentSkillDoc = await db.collection('students').doc(this.userProfile.alias).collection('skills').doc(skillName).get();

					if (studentSkillDoc?.exists) {
						const data = studentSkillDoc.data();
						const testResults = data.testResults || [];

						const currentJobResult = testResults.find(r => r.jobId === this.jobId);
						const passedOtherJob = testResults.find(r => r.pass === true);

						if (currentJobResult) {
							status = currentJobResult.pass ? 'Passed' : 'Failed';
							pass = currentJobResult.pass;
							jobSource = this.jobId;
						} else if (passedOtherJob) {
							status = 'Passed';
							pass = true;
							jobSource = passedOtherJob.jobId;
						} else if (testResults.length > 0) {
							status = 'Failed';
							pass = false;
							jobSource = testResults[0].jobId;
						}
					}

					// Match vetting test for the skill
					const matchingTests = vettingTests.filter(t => t.skill?.trim().toLowerCase() === normalizedSkill).sort((a, b) => b.created.toMillis() - a.created.toMillis());

					if (matchingTests.length > 0) {
						const latestTest = matchingTests[0];
						score = latestTest.score || 0;
						totalPoints = latestTest.totalPoints || 100;
						if (jobSource === '—') jobSource = latestTest.jobAlias || '—';
						if (status === 'Not Attempted') {
							status = latestTest.pass ? 'Passed' : 'Failed';
							pass = latestTest.pass;
						}
					}

					return {
						skillName,
						score,
						totalPoints,
						percentage: Math.round((score / totalPoints) * 100),
						pass,
						jobAlias: jobSource,
						status,
					};
				})
			);

			this.skillsAssessmentResults = skillResults;
		},
		promptLogin() {
			this.$router.push({ name: 'Login' });
		},
		async fetchJobData() {
			const jobSnapshot = await db.collection('jobs').where('jobId', '==', this.jobId).get();
			if (!jobSnapshot.empty) {
				this.jobData = jobSnapshot.docs[0].data();
			} else {
				throw new Error('Job not found.');
			}
		},
		closeViewTranscriptModal() {
			this.isAcademicTranscript = false;
		},
		viewVideoSubmission() {
			this.$emit('profileViewVideoSubmission', this.userProfile);
		},
		viewResume() {
			if (!this.auth) {
				this.errorAuth = true;
				this.authError = 'Please log in or sign up to view the resume.';
				return;
			}
			if (this.profile.cv) {
				window.open(this.profile.cv.url, '_blank');
			} else {
				this.$toast?.error('Resume not available');
			}
		},
		viewWrittenSubmission() {
			this.$emit('profileViewWrittenSubmission', this.userProfile);
		},
		viewAcademicTranscript(url) {
			if (url) {
				window.open(url, '_blank');
			} else {
				this.$toast?.error('Transcript not available');
			}
		},

		checkBtnFavourite() {
			return this.userProfile.favourite ? this.userProfile.favourite : this.userProfile.isTalentPoolFavourite;
		},
		showCommentsModal() {
			if (this.isTalentPool === '') {
				this.commentsModal = true;
			} else {
				this.talentCommentsModal = true;
			}
		},
		closeCommentsModal(payload) {
			this.commentsModal = payload;
		},
		closeTalentPoolCommentsModal(payload) {
			this.talentCommentsModal = payload;
		},
		async loadProfile(alias) {
			const studentDocRef = db.collection('students').doc(alias);
			const usersDocRef = db.collection('users').doc(alias);
			const applicationDocRef = db.collection('applications').doc(`${alias}-${this.jobId}`);

			const [studentDoc, usersDoc, qualificationsSnapShot, experiencesSnapShot, skillsSnapShot, applicationDoc] = await Promise.all([
				studentDocRef.get(),
				usersDocRef.get(),
				studentDocRef.collection('qualifications').get(),
				studentDocRef.collection('experiences').get(),
				studentDocRef.collection('skills').get(),
				applicationDocRef.get(),
			]);

			const allQualifications = qualificationsSnapShot.docs.map(doc => doc.data());

			const student = {
				...studentDoc.data(),
				name: usersDoc.data().name,
				surname: usersDoc.data().surname,
				email: usersDoc.data().email,
				phone: usersDoc.data().phone,
				qualifications: allQualifications,
				experiences: experiencesSnapShot.docs.map(doc => doc.data()),
				skills: skillsSnapShot.docs.map(doc => ({
					id: doc.id,
					...doc.data(),
				})),
				videoSubmissionUrl: applicationDoc.exists ? applicationDoc.data().videoSubmissionUrl || null : null,
				writtenSubmissionUrl: applicationDoc.exists ? applicationDoc.data().writtenSubmissionUrl || null : null,
				introductoryVideoUrl: studentDoc.data().introductoryVideoUrl || null, // 👈 ADD THIS LINE
			};

			return student;
		},
		async setFavourite() {
			this.$emit('setProfileFavourite', this.userProfile);
		},
		checkFavourite() {
			const favourite = this.userProfile.favourite ? this.userProfile.favourite : this.userProfile.isTalentPoolFavourite;
			this.isFavourited = favourite;
			this.favouriteButtonText = favourite ? 'Unfavourite Candidate' : 'Favourite Candidate';
		},
		toggleFavourite() {
			if (!this.auth) {
				this.errorAuth = true;
				this.authError = 'Please log in or sign up to access this feature.';
				return;
			}
			this.isFavourited = !this.isFavourited;
			this.setFavourite();
			this.favouriteButtonText = this.isFavourited ? 'Unfavourite Candidate' : 'Favourite Candidate';
		},
	},
	computed: {
		passedSkills() {
			if (!this.profile.skills) return [];
			return this.profile.skills.filter(skill => Array.isArray(skill.testResults) && skill.testResults.some(result => result.pass));
		},
		embeddedVideoUrl() {
			const url = this.profile.introductoryVideoUrl;
			if (!url) return null;
			if (url.includes('loom.com/share/')) {
				const parts = url.split('loom.com/share/');
				const videoId = parts[1]?.split('?')[0];
				if (videoId) return `https://www.loom.com/embed/${videoId}`;
			}

			if (url.includes('drive.google.com/file/d/')) {
				const parts = url.split('/d/');
				const fileId = parts[1]?.split('/')[0];
				if (fileId) return `https://drive.google.com/file/d/${fileId}/preview`;
			}

			if (url.includes('open?id=')) {
				const parts = url.split('open?id=');
				const fileId = parts[1]?.split('&')[0];
				if (fileId) return `https://drive.google.com/file/d/${fileId}/preview`;
			}

			try {
				const valid = new URL(url);
				return valid.href;
			} catch {
				console.warn('Invalid video URL:', url);
				return null;
			}
		},

		formattedUploadDate() {
			// You can enhance this to use a real date if it's stored in DB.
			// For now, return a static value or placeholder
			return 'Date Unknown';
		},
		status() {
			return this.showStatus;
		},
		checkProfile() {
			return this.checkLinkedIn || this.checkGitHub;
		},
		checkLinkedIn() {
			return this.profile.linkedIn && this.profile.linkedIn !== '';
		},
		checkGitHub() {
			return this.profile.github && this.profile.github !== '';
		},
		lastQualification() {
			if (!this.profile.qualifications || this.profile.qualifications.length === 0) {
				return {};
			}
			return this.profile.qualifications[this.profile.qualifications.length - 1];
		},
		getProfile() {
			return this.profile;
		},
	},
	async created() {
		this.loading = true;
		try {
			this.auth = firebase.auth().currentUser || null;
			this.profile = await this.loadProfile(this.userProfile.alias);

			if (this.jobId !== undefined) {
				await this.fetchJobData();
				posthog.capture('view_candidate_profile', {
					employerName: this.jobData.clientName,
					jobName: this.jobData.name,
					jobId: this.jobData.jobId,
				});
			}
			this.checkFavourite();
			await this.fetchSkillsAssessmentResults();
		} catch (error) {
			console.error('Error:', error);
		} finally {
			this.loading = false;
		}
	},
};
</script>
<style lang="scss" scoped>
.assessment-table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 1rem;

	th,
	td {
		border: 1px solid lightgrey;
		padding: 0.5rem;
		text-align: left;
	}

	th {
		background-color: #f5f5f5;
		font-weight: bold;
	}
}

// Utility
.btn-text-icon.favourited {
	color: #e2c800 !important;
}

.background {
	width: 100vw !important;
	height: 100vh !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
}

.background .logo-position {
	position: absolute;
	top: 40%;
	left: 47%;
	transform: translate(-50%, -50%);
}

.tag-pill {
	margin: 7px 5px 0 0;
	background-color: #ffedd5;
	padding: 3px 10px;
	border-radius: 50vw;
	font-size: 12px;
	color: #cb6c24;
	font-weight: bold;
	width: fit-content;
}

// Consistent md-button styling
.md-button {
	background-color: white !important;
	border: 1px solid lightgrey !important;
	color: black !important;
	box-shadow: none !important;
	transition: all 0.3s ease;

	.md-icon {
		color: darkorange !important;
	}

	&:hover {
		background-color: #efefef !important;
		color: black !important;
	}
	&:focus,
	&:active {
		box-shadow: none !important;
		background: linear-gradient(90deg, #f6f5f5, #f6f5f5) !important; // darker hover
		color: black !important;

		.md-icon {
			color: darkorange !important;
		}
	}
	&:active:focus {
		color: black !important;
	}
}

.blurred {
	filter: blur(5px); /* Adjust the blur amount as needed */
	transition: filter 0.3s ease-in-out; /* Smooth transition for blurring/unblurring */
	pointer-events: none; /* Optional: Prevent interaction with blurred content */
	user-select: none; /* Optional: Prevent selecting blurred text */
}

.blurred::after {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(255, 255, 255, 0.7); /* A semi-transparent white overlay */
	z-index: 1; /* Ensure it's above the blurred content */
}

.login-overlay-button {
	position: relative;
	top: 50%; /* Center vertically */
	left: 50%; /* Center horizontally */
	transform: translate(-50%, -50%); /* Adjust for button's own size */
	z-index: 2; /* Ensure button is above the blur and overlay */
	padding: 10px 20px;
	background: linear-gradient(90deg, #ec6f28, #e65229) !important; // orange gradient
	color: white;
	border: none;
	border-radius: 5px;
	cursor: pointer;
	font-size: 1em;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Add some shadow for prominence */
	transition: background-color 0.3s ease;
}

h3,
h4,
h5,
ul,
li,
p {
	color: rgb(35, 35, 35);
}
.md-button.jb-standard {
	background: linear-gradient(90deg, #ec6f28, #e65229) !important; // orange gradient
	color: white !important;
	border: none !important;
	font-weight: bold;

	.md-icon {
		color: white !important;
	}

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(90deg, #e95d1f, #d7431a) !important; // darker hover
		color: white !important;
		box-shadow: none !important;

		.md-icon {
			color: white !important;
		}
	}
}

.btn-text {
	background-color: white !important;
	color: black !important;

	&.comment {
		width: 100%;
	}
}

.btn-text-icon {
	margin-right: 5px;
	color: darkorange !important;
	opacity: 1 !important;
	transition: color 0.3s ease;

	&.active {
		color: white !important;
	}
	&.favourited {
		color: #e2c800 !important;
	}
}

.section-box {
	width: 100%;
	border: 1px solid lightgrey;
	border-radius: 10px;
	padding: 10px;
	margin-top: 2rem;
	text-align: left;

	.md-icon {
		color: darkorange;
	}

	&.no-top-margin {
		margin-top: 0;
	}
	&.contact {
		margin-top: 0;
	}
}

.section-header {
	font-weight: bold;
	gap: 0.5rem;
	margin-bottom: 0.75rem;
}

.section-content.wrap {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
}

.comment-input {
	width: 100%;
	border: 1px solid lightgrey;
	border-radius: 10px;
	padding: 5px;
	margin-bottom: 10px;
}

.border {
	width: 100%;
	border: 1px solid lightgrey;
	border-radius: 10px;
	padding: 10px;
	margin-top: 2rem;
	text-align: left;

	.md-icon {
		color: darkorange !important;
	}
	&.right {
		margin-top: 0;
	}
}

.section-container {
	.section-title {
		font-weight: bold;
	}
	.md-icon {
		color: darkorange !important;
	}

	.section-card {
		display: flex;
		width: 100%;
		justify-content: space-between;
		border-bottom: 1px solid lightgrey;
		padding-bottom: 1rem;

		.section-dates {
			font-size: 16px;
		}

		h3 {
			font-weight: bold;
			font-size: 16px;
		}
		h4 {
			font-size: 16px;
			.md-icon {
				color: darkorange !important;
			}
		}
	}
}

.profile-content-container {
	padding-bottom: 3rem;
	height: fit-content;

	.profile-actions-container {
		width: 100%;
		text-align: left;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 2rem;
		border: 1px solid lightgrey;
		border-radius: 10px;
		padding: 10px;

		.actions-left {
			.send-offer-btn {
				margin-right: 1rem;
			}
		}
	}

	.content {
		width: 100%;
		display: flex;
		margin-top: 2rem;

		.content-left {
			flex: 0.7;
			text-align: left;
			padding: 1rem;

			.main-information {
				.img {
					width: 80px;
					height: 80px;
					object-fit: cover;
					border-radius: 40vw;
					margin-right: 1rem;
					object-position: center;
				}

				display: flex;
				align-items: center;
				border: 1px solid lightgrey;
				border-radius: 10px;
				padding: 10px;

				h3 {
					margin-bottom: -1.3rem;
					font-weight: bold;
				}
				h4 {
					margin-bottom: -1.3rem;
					color: darkorange;
				}
				h5 {
					font-size: 12px;
				}
			}

			.document-container {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}

			.video-container {
				h4 {
					font-weight: bold;
				}
				p {
					margin-top: 1rem;
				}
				.md-icon {
					color: darkorange !important;
				}

				.video-player {
					width: 100%;
					height: auto; // fallback
					position: relative;
					background-color: white;
					border-radius: 10px;
					display: flex;
					align-items: center;
					justify-content: center;
					overflow: hidden;
					object-fit: contain;

					iframe {
						width: 100%;
						height: 100%;
						border: none;
					}
				}
			}
		}

		.content-right {
			flex: 0.3;
			padding: 1rem;

			.md-icon {
				color: darkorange;
			}

			.full-width {
				width: 100%;
			}
		}
	}
}
</style>
